import OapCarouselControls from './code/Scripts/components/OapCarouselControls.vue';

export default {
  components: {
    OapCarouselControls,
  },
};
